import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const labelDefaultVariants = {
  "sectionVariant": "default",
  "dividerHighlight": false,
  "idExternal": false,
  "idOverdue": false
}
const labelCompoundVariants = []

const labelSlotNames = [
  [
    "root",
    "printLabel__root"
  ],
  [
    "group",
    "printLabel__group"
  ],
  [
    "details",
    "printLabel__details"
  ],
  [
    "section",
    "printLabel__section"
  ],
  [
    "sku",
    "printLabel__sku"
  ],
  [
    "emoji",
    "printLabel__emoji"
  ],
  [
    "pill",
    "printLabel__pill"
  ],
  [
    "bulk",
    "printLabel__bulk"
  ],
  [
    "bulkBox",
    "printLabel__bulkBox"
  ],
  [
    "divider",
    "printLabel__divider"
  ],
  [
    "name",
    "printLabel__name"
  ],
  [
    "address",
    "printLabel__address"
  ],
  [
    "message",
    "printLabel__message"
  ],
  [
    "id",
    "printLabel__id"
  ],
  [
    "graphic",
    "printLabel__graphic"
  ],
  [
    "messageOverlay",
    "printLabel__messageOverlay"
  ],
  [
    "messageText",
    "printLabel__messageText"
  ]
]
const labelSlotFns = /* @__PURE__ */ labelSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, labelDefaultVariants, getSlotCompoundVariant(labelCompoundVariants, slotName))])

const labelFn = memo((props = {}) => {
  return Object.fromEntries(labelSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const labelVariantKeys = [
  "sectionVariant",
  "dividerHighlight",
  "idExternal",
  "idOverdue"
]
const getVariantProps = (variants) => ({ ...labelDefaultVariants, ...compact(variants) })

export const label = /* @__PURE__ */ Object.assign(labelFn, {
  __recipe__: false,
  __name__: 'label',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: labelVariantKeys,
  variantMap: {
  "sectionVariant": [
    "default",
    "message"
  ],
  "dividerHighlight": [
    "true",
    "false"
  ],
  "idExternal": [
    "true",
    "false"
  ],
  "idOverdue": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, labelVariantKeys)
  },
  getVariantProps
})